import { SVGProps, FC } from 'react'

interface IProps extends SVGProps<SVGSVGElement> {}

const Translate: FC<IProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36 36"
      fill="none"
      stroke="currentColor"
      {...props}
    >
      <path
        d="M28.5899 28.005L25.3799 21.6L22.1699 28.005"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.7549 26.865H28.0349"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.3798 33C21.1798 33 17.7598 29.5949 17.7598 25.3799C17.7598 21.1799 21.1648 17.76 25.3798 17.76C29.5798 17.76 32.9998 21.1649 32.9998 25.3799C32.9998 29.5949 29.5948 33 25.3798 33Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.53001 3H13.41C16.515 3 18.015 4.50003 17.94 7.53003V13.41C18.015 16.515 16.515 18.015 13.41 17.94H7.53001C4.50001 18 3 16.5 3 13.395V7.51501C3 4.50001 4.50001 3 7.53001 3Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5153 8.77502H7.42529"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.4551 7.755V8.77499"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.9852 8.76007C11.9852 11.3851 9.93016 13.515 7.41016 13.515"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.5152 13.515C12.4202 13.515 11.4302 12.93 10.7402 12"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3 22.5C3 28.305 7.695 33 13.5 33L11.925 30.375"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33 13.5C33 7.695 28.305 3 22.5 3L24.075 5.625"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default Translate
